import React from "react";
import type { GeneratedSlides, SlideStyle, ColorScheme } from "../types";
import { SlideRenderer } from "../SlideTemplates/SlideRenderer";
import { getSlideColor, getSlideBgColor } from "../utils";

interface SlidePreviewSectionProps {
  generatedSlides: GeneratedSlides;
  selectedSlide: number;
  slideStyle: SlideStyle;
  colorScheme: ColorScheme;
}

export const SlidePreviewSection: React.FC<SlidePreviewSectionProps> = ({
  generatedSlides,
  selectedSlide,
  slideStyle,
  colorScheme,
}) => {
  const primaryColor = getSlideColor(colorScheme);
  const bgColor = getSlideBgColor(colorScheme);

  const currentSlide = generatedSlides?.slides?.[selectedSlide];

  if (!currentSlide) return null;

  return (
    <div className="flex-1">
      <div
        className="rounded-xl border overflow-hidden shadow-lg"
        style={{
          borderColor: "var(--border-color)",
          aspectRatio: "16/9",
          backgroundColor: bgColor,
        }}
      >
        <SlideRenderer
          slide={currentSlide}
          primaryColor={primaryColor}
          bgColor={bgColor}
          slideStyle={slideStyle}
        />
      </div>
      <div className="mt-3 text-sm text-(--text-tertiary)">
        <p>{currentSlide?.notes}</p>
      </div>
    </div>
  );
};
